import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }
            let error = '';
            if (err.error) {
                if (err.error.errors) {
                    error = err.error.errors;
                    if (err.error.errors.Details) {
                        error = err.error.errors.Details;
                    }
                } else if (err.error.result) {
                    error = err.error.result;
                }
            } else if (err.errors) {
                error = err.errors;
            } else if (err.message) {
                error = err.message;
            }
            return throwError(error);
        }));
    }
}
